import React, { useState,useEffect } from 'react'
import FilterDropdown from 'live/components/forms/ui/filter-dropdown'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import './filters.scss'
import FiltersPipes from '../FiltersPipes/FiltersPipes'

export const Filters = ({ disabledFilters, applyCallback, removeAll, filters,activeFilters }: any) => {
    const [filtersAndSelectedOpen, setFiltersAndSelectedOpen] = useState<boolean>(false)
    const [isAppling, setIsAppling] = useState<boolean>(false)
    const [filtersActive, setFiltersActive] = useState<any>({})
    const [isFiltersClear, setIsFiltersClear] = useState<boolean>(false)

    useEffect(()=>{
        if(activeFilters) setFiltersActive(activeFilters)
    },[activeFilters])
    
    const apply = (): void => {
        setIsAppling(true)
        setFiltersAndSelectedOpen(!filtersAndSelectedOpen)
        
        new Promise(async (resolve, reject) => {
            await applyCallback(filtersActive)
            setIsAppling(false)
            setIsFiltersClear(false)
        })
    }

    const handleRemoveAll = (): void => {
        setIsFiltersClear(true)
        setFiltersActive({})
        setFiltersAndSelectedOpen(!filtersAndSelectedOpen)
        applyCallback({})
    }

    return (
        <div className="filters-dropdown">
            <FilterDropdown
                hideTitle={true}
                open={filtersAndSelectedOpen}
                onClick={() => {
                    setFiltersAndSelectedOpen(!filtersAndSelectedOpen)
                }}
                containerClassName="smart-utils-override-dropdown"
                disableTooltip={true}
                btnCls={` ${filtersAndSelectedOpen ? 'is-open' : ''} ${disabledFilters && 'disabled'} btn has-icon has-caret btn-default btn-block btn-custom`}
                btnLabel={
                    <span>
                        <i className={`${Object.keys(filtersActive).length > 0 ? 'fas' : 'far'} fa-filter`} />
                        <span className="label-custom"> {i18n('Filters')} </span>
                        <i className="fas fa-caret-down" />
                    </span>
                }
            >
                <div>
                    <StyleContainer>
                        <FiltersPipes
                            filters={filters.filters}
                            filtersActive={filtersActive}
                            callbackChange={setFiltersActive}
                            clearFilters={isFiltersClear}
                        />
                    </StyleContainer>
                    <StyleContainerBtn>
                        <button
                            disabled={isAppling || Object.keys(filtersActive).length === 0}                            
                            className="btn btn-primary"
                            onClick={apply}
                        >
                            {isAppling ? <i className="fas fa-spinner fa-spin"></i> : <></>}
                            {i18n('Apply')}
                        </button>
                        <StyleBtnRemove className="btn" onClick={handleRemoveAll}>
                            {i18n('Remove filters')}
                        </StyleBtnRemove>
                    </StyleContainerBtn>
                </div>
            </FilterDropdown>
        </div>
    )
}

export default React.memo(Filters)

const StyleBtnRemove = styled.button`
    background: none;
    color: ${({ theme }) => theme['blue-500']};
    border: none;
`

const StyleContainer = styled.div`    
    overflow: auto;
    padding: 16px;


    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #bac0cb;
        border-radius: 10px;
    }
`

const StyleContainerBtn = styled.div`
    padding: 10px 15px;
`
